import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { Rule } from 'src/app/sharedModule/models/rule.model';
import { AutomationRulesActions } from '../actions';

export const featureKey = 'automation-rules';

export type TemplateData = {
  parameters: {
    conditions: Array<any>;
    actions: Array<any>;
  };
  'ng-template': string;
  notVerifiedName: string;
};

export interface State {
  [featureKey]: AutomationRulesState;
}

export interface AutomationRulesState {
  rules: Rule[];
  templateData: TemplateData;
  isLoading: boolean;
}

export const initialState: AutomationRulesState = {
  rules: null,
  templateData: null,
  isLoading: false,
};

export const reducer = createReducer(
  initialState,
  // loadRules
  on(AutomationRulesActions.loadRules, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(AutomationRulesActions.loadRulesSuccess, (state, { rules }) => ({
    ...state,
    rules,
    isLoading: false,
  })),
  on(AutomationRulesActions.loadRulesFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    isLoading: false,
  })),

  // loadTemplateData
  on(AutomationRulesActions.loadTemplateData, (state) => ({
    ...state,
    isLoading: true,
    templateData: null,
    rules: null,
  })),
  on(AutomationRulesActions.loadTemplateDataSuccess, (state, { templateData }) => ({
    ...state,
    templateData,
    isLoading: false,
  })),
  on(AutomationRulesActions.loadTemplateDataFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    isLoading: false,
  })),
);

export const selectAutomationRulesState = createFeatureSelector<State, AutomationRulesState>(featureKey);

export const selectIsLoading = createSelector(
  selectAutomationRulesState,
  (state: AutomationRulesState) => state?.isLoading,
);

export const selectTemplateData = createSelector(
  selectAutomationRulesState,
  (state: AutomationRulesState) => state?.templateData,
);

export const selectRulesData = createSelector(
  selectAutomationRulesState,
  (state: AutomationRulesState) => state?.rules,
);
